const css = `/* Change colors in this file to style to your needs on a global level. 
Certain colors are used for different and multiply types of elements. 
For greater control over colors visit each components .scss file. */
.small-dark {
  color: #ffffff !important;
}

.blog-container {
  border-radius: 10px;
  color: #586069;
  background-color: #fff;
  box-shadow: 0 0 36px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  height: 200px;
}

.blog-title {
  color: #262626;
  font-size: 1.375rem;
  line-height: 24px;
  font-weight: 700;
  margin-left: 20px;
  margin-right: 20px;
  margin-bottom: 14px;
  margin-top: 32px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.small {
  font-size: 1.063rem;
  font-weight: 400;
  line-height: 1.5rem;
  color: #666666;
  padding: 0px 20px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  margin: 0px;
}

.go-corner {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 32px;
  height: 32px;
  overflow: hidden;
  top: 0;
  right: 0;
  background-color: #55198b;
  border-radius: 0 4px 0 32px;
}

.go-arrow {
  margin-top: -4px;
  margin-right: -4px;
  color: #ffffff;
  font-family: courier, sans;
}

.blog-card {
  display: block;
  position: relative;
  background-color: transparent;
  border-radius: 4px;
  text-decoration: none;
  z-index: 0;
  overflow: hidden;
  height: 100%;
}

.blog-card::before {
  content: "";
  position: absolute;
  z-index: -1;
  top: -16px;
  right: -16px;
  background: #55198b;
  height: 32px;
  width: 32px;
  border-radius: 32px;
  transform: scale(1);
  transform-origin: 50% 50%;
  transition: transform 0.4s ease-out;
}

.blog-card:hover::before {
  transform: scale(30);
}

.blog-card:hover > .small {
  transition: all 0.3s ease-out;
  color: rgba(255, 255, 255, 0.8);
}

.blog-card:hover > h3 {
  transition: all 0.3s ease-out;
  color: #ffffff;
}

@media screen and (max-width: 480px) and (min-width: 300px), (min-width: 925px) and (max-width: 1024px), (min-width: 1405px) and (max-width: 1550px) {
  .blog-card:hover::before {
    transform: scale(30);
  }
}
@media screen and (min-width: 481px) and (max-width: 675px), (min-width: 1025px) and (max-width: 1404px), (min-width: 1551px) {
  .blog-card:hover::before {
    transform: scale(40);
  }
  .blog-card::before {
    transition: transform 0.45s ease-out;
  }
}
@media screen and (min-width: 675px) and (max-width: 860px) {
  .blog-card:hover::before {
    transform: scale(50);
  }
  .blog-card::before {
    transition: transform 0.5s ease-out;
  }
}
@media screen and (min-width: 860px) and (max-width: 924px) {
  .blog-card:hover::before {
    transform: scale(60);
  }
  .blog-card::before {
    transition: transform 0.5s ease-out;
  }
}
@media screen and (max-width: 480px) and (min-width: 300px) {
  .blog-title {
    font-size: 1.125rem;
  }
}
.blog-card-shadow {
  box-shadow: 1px 0px 20px #ffffff;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
